fx.ns("shared.popups", class ConfirmDeleteTheme extends fx.components.Popup{
    
    constructor(data)
    {
        super(data);
        this.contentWidth = 500;
        this.contentHeight = 270;
    }


    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
        this.on("click", this.close, this.cancelButton);
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Etes-vous sûre ?"), className:"title"}), {height:30, left:0, top:20, width:"100%"});
        this.addChild(new fx.components.Text({text:fx.text("En supprimant ce thème, toutes les mises en pages liées seront supprimées définitivement, et les clients n'y auront plus accès immédiatement."), className:"text"}), {height:80, left:0, top:90, width:"100%"});

        let hcontainer = new fx.components.HBox("buttons");

        this.okButton = new fx.components.Button({label : fx.text("Je le supprime"), type : "filled"});
        this.cancelButton = new fx.components.Button( {label :fx.text("Non")} );

        hcontainer.addChild(this.cancelButton)
        hcontainer.addChild(this.okButton)

        this.addChild(hcontainer, {bottom:20, height:60, left:"center"});
    }


    onConfirm()
    {
        this.data.delete(true);
        this.close();
    }

});